import React, { useEffect } from 'react'
import { BrComponent } from '@bloomreach/react-sdk'
import FooterNav from './FooterNav.jsx'
import FooterConnectBanner from './FooterConnectBanner.jsx'
import FooterDefaultContent from './FooterDefaultContent.jsx'
import { isInstitutional } from '../../../global/authentication/authentication-manager.js'
import DisclosureLinks from './DisclosureLinks.jsx'
import FooterDisclosure from './FooterDisclosure.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'
import { SWRConfig } from 'swr'
import { buildBundleUrl, useFetch, sessionStorageProvider } from './services.js'
import DisclosureModal from '../../../components/Modal/disclosureModal.jsx'

const FooterLegal = () => {
  return (
    <section className="Footer-legal u-marginTop8gu u-sizeConstrained">
      <DisclosureLinks />
      <BrComponent path="footer-disclosures">
        <FooterDisclosure />
      </BrComponent>
    </section>
  )
}

export const Footer = () => {
  const url = buildBundleUrl('cti-advisor.contact-us-mutual-funds')

  const { data, isError, isLoading } = useFetch(url)

  if (isError || isLoading) return <div></div>
  return (
    <>
      <a
        className="Footer-jumpLink u-linkComplex u-hidden u-sm-hidden u-md-hidden"
        href="#contact-us"
        aria-label="Contact Us"
      >
        <span className="Footer-jumpLinkText u-textSizeMsrp2 u-flex u-flexAlignItemsCenter">
          <span className="Icon--material u-textSizeMsrp2 u-marginRight1gu">
            phone_outline
          </span>
          <span className="u-linkComplexTarget hover-underline-animation u-textSecondary u-textSizeMsrp2 u-posRelative">
            {data.bundles.default.title}
          </span>
        </span>
      </a>

      <footer className="Footer u-bgColorWhite u-posRelative">
        <FooterDefaultContent />
        <div
          id="footer-navigation"
          className="u-decoBackgroundLight u-paddingBottom6gu u-sm-paddingBottom0"
          data-analytics-component-name="Footer Navigation"
          data-qa-automation="footer-navigation"
        >
          {!isInstitutional() && <FooterConnectBanner />}
          <BrComponent path="footer-nav">
            <FooterNav />
          </BrComponent>
        </div>
        <FooterLegal />
      </footer>
      {isInstitutional() && window.location.pathname !== '/institutional/investor-redirect' && <DisclosureModal />}
      <ie-modal></ie-modal>
    </>
  )
}

export default function ErrorWrapperFooter(props) {
  useEffect(() => {
    const existingLink = document.getElementById('ot-sdk-btn')

    if (!existingLink) {
      const script = document.createElement('script')

      script.src =
        'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed'
      script.async = true
      script.id = 'geofeedScript'

      document.head.appendChild(script)
    }
  }, [])

  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? <p>Error in Footer component</p> : null
      }
    >
      <SWRConfig value={{ provider: sessionStorageProvider }}>
        <Footer {...props}></Footer>
      </SWRConfig>
    </ErrorBoundary>
  )
}
